import axios from "axios";
import { serverApi, serverUrl } from "../confing/confing";


export const getAllExperts = (id) => {
  const url = `${serverApi}/expert/koja?zoneId=${id}`;
  return axios.get(url);
};

export const CreateVerifyCode = (sendData) => {
  const url = `${serverApi}/user/mobile`;
  return axios.post(url, sendData);
};

export const sendVerifyCode = (sendData) => {
  const url = `${serverApi}/user/verify`;
  return axios.post(url, sendData);
};

export const getAllZones = () => {
  const url = `${serverApi}utils/zones`;
  return axios.get(url);
};

export const getAllRealEstate = () => {
  const url = `${serverApi}realstate/koja`;
  return axios.get(url);
};

export const getAllCategory = () => {
  const url = `${serverApi}utils/categories`;
  return axios.get(url);
};
export const getAllPrice = () => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}setting/price`;
  return axios.get(url,  { headers: { authorization: `Bearer ${token}` }});
};

export const getAllExpertsRequest = (id,type) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}/expert?type=${type}&zoneId=${id}`;
  return axios.get(url ,  { headers: { authorization: `Bearer ${token}` }});
};

export const getTimeExpert = (id) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}/expert/${id}/times?from=&to=`;
  return axios.get(url ,  { headers: { authorization: `Bearer ${token}` }});
};

export const sendRequest = (sendData) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}/user/request`;
  return axios.post(url, sendData , { headers: { authorization: `Bearer ${token}` }});
};

export const getAllRequest = (id,type) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}/user/requests`;
  return axios.get(url ,  { headers: { authorization: `Bearer ${token}` }});
};
export const getEndRequest = (id,type) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}/user/end_requests`;
  return axios.get(url ,  { headers: { authorization: `Bearer ${token}` }});
};

export const sendTicket = (sendData) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}/ticket`;
  return axios.post(url, sendData , { headers: { authorization: `Bearer ${token}` }});
};
export const getAllMessages = () => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}/noti`;
  return axios.get(url ,  { headers: { authorization: `Bearer ${token}` }});
};
export const sendPayRequest = (Rtoken) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}/pay`;
  return axios.post(url, {requestToken:Rtoken} , { headers: { authorization: `Bearer ${token}` }});
};
export const getPayLink = (Rtoken) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}/pay/${Rtoken}`;
  return axios.get(url , { headers: { authorization: `Bearer ${token}` }});
};

export const sendForRealState = (sendData) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}/realstate/access`;
  return axios.post(url, sendData , { headers: { authorization: `Bearer ${token}` }});
};

export const sendInquery = (RToken) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}user/inquery/${RToken}`;
  // console.log(url)
  return axios.get(url);
};

export const AdminLogin = (sendData) => {
  const url = `${serverApi}admin/login`;
  return axios.post(url, sendData );
};

export const ExpertRequests = (limit,page) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}expert/requests?limit=${limit}&page=${page}`;
  // console.log(url)
  return axios.get(url, { headers: { authorization: `Bearer ${token}` }} );
};

export const ExpertTime = () => {
  let token = localStorage.getItem("token")
  const url = `${serverUrl}/expert/time`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` }} );
};
export const SendExpertTime = (data) => {
  let token = localStorage.getItem("token")
  const url = `${serverUrl}/expert/time`;
  console.log(url)
  return axios.post(url,data, { headers: { authorization: `Bearer ${token}` }} );
};

export const ExpertNewRequest = (sendData) => {
  let token = localStorage.getItem("token")
  const url = `${serverUrl}/expert/create_request`;
  console.log(url)
  return axios.post(url,sendData, { headers: { authorization: `Bearer ${token}` }} );
};

export const ExpertWallet = () => {
  let token = localStorage.getItem("token")
  const url = `${serverUrl}/expert/wallet`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` }} );
};
export const ExpertStatistics = () => {
  let token = localStorage.getItem("token")
  const url = `${serverUrl}/expert/statistics`;
  return axios.get(url, { headers: { authorization: `Bearer ${token}` }} );
};
export const TimesList = () => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}utils/time_steps  `;
  // console.log(url)
  return axios.get(url, { headers: { authorization: `Bearer ${token}` }} );
};

export const getAllDoccument = () => {
  const url = `${serverApi}utils/documents`;
  return axios.get(url);
};
export const getDescriptions = () => {
  const url = `${serverApi}utils/descriptions`;
  return axios.get(url);
};
export const getMoreDescriptions = () => {
  const url = `${serverApi}utils/more_desc`;
  return axios.get(url);
};

export const getPoints = () => {
  const url = `${serverApi}utils/points`;
  return axios.get(url);
};

export const getSheetDesc = () => {
  const url = `${serverApi}utils/sheet_desc`;
  return axios.get(url);
};

export const getSheetId = (data) => {
  let token = localStorage.getItem("token")
  const url = `${serverUrl}/expert/sheet/create`;
  return axios.post(url , data , { headers: { authorization: `Bearer ${token}` }});
};

export const getSheetInfo = (Rtoken) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}request/${Rtoken}`;
  console.log(url)
  return axios.get(url  , { headers: { authorization: `Bearer ${token}` }});
};

export const addSheet = (data) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}sheet`;
  return axios.post(url , data , { headers: { authorization: `Bearer ${token}` }});
};

export const sheetInfo = (id) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}sheet/${id}`;
  return axios.get(url , { headers: { authorization: `Bearer ${token}` }});
};

export const checkSheet = (id) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}sheet/check`;
  console.log(url)
  return axios.post(url , {sheetId:id} , { headers: { authorization: `Bearer ${token}` }});
};
export const sheetSend = (data) => {
  let token = localStorage.getItem("token")
  const url = `${serverApi}sheet/send`;
  return axios.post(url , data , { headers: { authorization: `Bearer ${token}` }});
};

export const updateSheet = (data) => {
  let token = localStorage.getItem("token")
  const url = `${serverUrl}/expert/refresh_request`;
  console.log(`${serverUrl}/expert/refresh_request`)
  return axios.post(url , data , { headers: { authorization: `Bearer ${token}` }});
};

export const getCash = (data) => {
  let token = localStorage.getItem("token")
  const url = `${serverUrl}/expert/request_inquery`;
  return axios.post(url , {cost:data} , { headers: { authorization: `Bearer ${token}` }});
};